export var DealerErrors;
(function (DealerErrors) {
    DealerErrors["DEALER_CONNECTION_ERROR"] = "DEALER_CONNECTION_ERROR";
    DealerErrors["DEALER_AUTHENTICATION_FAILED"] = "DEALER_AUTHENTICATION_FAILED";
    DealerErrors["DEALER_ERROR"] = "DEALER_ERROR";
    DealerErrors["DEALER_DISCONNECTED_BEFORE_EVENTS"] = "DEALER_DISCONNECTED_BEFORE_EVENTS";
    DealerErrors["ENDPOINT_NOT_DEFINED"] = "ENDPOINT_NOT_DEFINED";
    DealerErrors["INVALID_ENDPOINT"] = "INVALID_ENDPOINT";
})(DealerErrors || (DealerErrors = {}));
//# sourceMappingURL=typedefs.js.map